import React from 'react';
import styled from 'styled-components';

import InitialSelect from 'hive-admin/src/components/Input/Select';

import tests from '../helpers/tests';

// const popconfirm = {
//   title: (
//     <p style={{ maxWidth: '240px' }}>
//       Are you sure? This action cannot be undone.
//     </p>
//   ),
//   okButtonProps: { type: 'danger', icon: 'exclamation-circle' },
//   okText: 'Proceed',
//   cancelButtonProps: { },
// };

// const Select = styled(props => <InitialSelect {...props} open={false} />)`

// `;

const fields = [
  // // SMS
  // ['FieldTitle', {
  //   title: 'Sending',
  //   // eslint-disable-next-line max-len
  //   subtitle: 'Test system services by sending arbitrary messages.',
  // }],
  // ['ActionWithFormModal', {
  //   name: 'sms-send',
  //   title: 'Send SMS',
  //   fields: [
  //     ['FieldSelect', {
  //       name: 'to',
  //       label: 'To',
  //       mode: 'tags',
  //       // eslint-disable-next-line max-len
  //       placeholder: 'International phone numbers (+381...) separated by space',
  //       tokenSeparators: [' '],
  //       Component: Select,
  //     }],
  //     ['FieldSelect', {
  //       name: 'provider',
  //       label: 'Provider',
  //       initialValue: null,
  //       choices: [
  //         { value: null, label: 'Auto' },
  //         { value: 'twilio', label: 'Twilio' },
  //         { value: 'rivet', label: 'Rivet' },
  //       ],
  //     }],
  //     ['FieldTextArea', {
  //       name: 'body',
  //       label: 'Message',
  //       placeholder: 'Message',
  //       initialValue: 'Test',
  //     }],
  //   ],
  //   actions: [
  //     ['ActionWithRequest', {
  //       name: 'send',
  //       title: 'Send',
  //       skip: [],
  //       getRequestConfig: props => ({
  //         url: 'development/sms/send',
  //         method: 'POST',
  //         data: props.form.getFieldsValue(),
  //       }),
  //     }],
  //   ],
  // }],
  ['ActionWithRequest', {
    name: 'import',
    title: 'Migrate Data',
    skip: [],
    getRequestConfig: _props => ({
      url: 'development/migrate-data',
      method: 'POST',
    }),
  }],
];

export default [
  'PageSingle',
  {
    id: 'devtools',
    // icon: 'code',
    title: 'Dev Tools',
    path: '/devtools',
    label: 'Dev Tools',
    headerTitle: 'Dev Tools',
    renderHeaderTitle: () => 'Dev Tools',
    hidden: false,
    activity: 'edit',
    url: '/development',
    redirect: [['redirect.unauthorized']],
    fields,
    actions: [],
    skip: [tests.viewerIsNotThehiveRsAdmin],
  },
];
